import { ICircleQueryParams } from "./ICircleQueryParams";
import { IMobilyticsPlaceQueryParams } from "./IMobilyticsPlaceQueryParams";
import { IPolygonQueryParams } from "./IPolygonQueryParams";

export type MobilyticsQueryParam = ICircleQueryParams | IPolygonQueryParams | IMobilyticsPlaceQueryParams;